import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    title: 'Activate the insurance',
  },
  fr: {
    title: 'Activer l’assurance',
  },
});

export default locales;
